import { defer } from "@tanstack/react-router";
import { loadProductGroups, type ProductGroupFilters } from "../services/productGroupService";
import { mapODataProductGroupDtoArrayToRows } from "../mappers/productGroupMapper";
import type { ProductGroupRow } from "../routes/cooling-regimes-product-group";

export interface CoolingRegimeProductGroupLoaderResult {
  rows: ProductGroupRow[];
  totalCount: number;
  error?: string;
}

/**
 * Loader for cooling regime product group data that transforms OData API data to table rows
 */
export async function coolingRegimeProductGroupLoader(
  filters: ProductGroupFilters,
): Promise<CoolingRegimeProductGroupLoaderResult> {
  const result = await loadProductGroups(filters);

  if (result.error) {
    return {
      rows: [],
      totalCount: 0,
      error: result.error.message,
    };
  }

  const rows = mapODataProductGroupDtoArrayToRows(result.value);

  return {
    rows,
    totalCount: result["@odata.count"] || rows.length,
    error: undefined,
  };
}

/**
 * Creates a deferred loader for TanStack Router
 */
export function createCoolingRegimeProductGroupDeferredLoader(search: ProductGroupFilters) {
  return {
    data: defer(coolingRegimeProductGroupLoader(search)),
  };
}
